import * as tslib_1 from "tslib";
/** @jsx jsx */

/** Do not edit this file directly. Edit the template in generate-icons.js **/

import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "../../Theme/Providers";
export var IconArrowLeft = function IconArrowLeft(_a) {
  var _b = _a.size,
      size = _b === void 0 ? "md" : _b,
      color = _a.color,
      otherProps = tslib_1.__rest(_a, ["size", "color"]);

  var theme = useTheme();
  var width = typeof size == "string" ? theme.iconSizes[size] : size;
  var stroke = color || theme.colors.text.default;
  return jsx("svg", tslib_1.__assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: width,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), jsx("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), jsx("polyline", {
    points: "12 19 5 12 12 5"
  }));
};
IconArrowLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};